import { TonedenSubscriptionResponseObject } from '@eventbrite/marketing-hub-ui';
import { Nullable } from '@eventbrite/ts-utils';
import React from 'react';

export type BoostSubscriptionContextType = {
    isAuthedToToneden: boolean;
    subscriptionData: Nullable<TonedenSubscriptionResponseObject>;
    setTonedenSubscription: Function;
    subscriptionStatus: SubscriptionStatus;
    setSubscriptionStatus: Function;
    onCardAddedCallback: Function;
    subscriptionLoading: boolean;
    tonedenSubscription:
        | TonedenSubscriptionResponseObject['subscription']
        | null;
};

export enum SubscriptionStatus {
    REQUIRES_PAYMENT_METHOD,
    REQUIRES_SUB,
    REQUIRES_UPGRADE,
    ELIGIBLE,
}

export const BoostSubscriptionContext =
    React.createContext<BoostSubscriptionContextType>({
        isAuthedToToneden: false,
        subscriptionData: null,
        tonedenSubscription: null,
        setTonedenSubscription: () => ({}),
        subscriptionStatus: SubscriptionStatus.REQUIRES_SUB,
        setSubscriptionStatus: () => ({}),
        onCardAddedCallback: () => ({}),
        subscriptionLoading: false,
    });
